<form [formGroup]="phoneForm">
  @if (modalActive) {
    <div class="phone-modal-scrim"></div>
  }
  @if (showPhoneCapture) {
    <div
      class="w-full fixed bottom-0 z-50 transition-all pointer-events-none"
      [ngClass]="useInverseSlideup ? 'text-black' : 'text-vis-reverse'"
      [class]="isMinimized ? 'transform translate-y-[82%]  sm:translate-y-[72%]' : ''"
      [class.phone-modal]="modalActive"
      [class.phone-no-transition]="suppressTransition"
    >
      <div
        class="mx-auto w-full sm:max-w-[890px] flex flex-col p-v-spacing pt-0 px-0 relative pb-8 banner pointer-events-auto"
        [ngClass]="useInverseSlideup ? 'slideup-inverse' : 'bg-ace-pink-600 rounded-t-md'"
        [class.minimized]="isMinimized"
      >
        @if (displayConfetti) {
          <canvas id="phone-capture-canvas" style="position: absolute; width: 575px; height: 306px; left: 0px; bottom: 0px;"></canvas>
        }
        <div
          class="absolute right-6 cursor-pointer transition-all delay-100"
          [class]="!isMinimized ? 'rotate-180 top-6' : 'rotate-0  top-3'"
          (click)="!isSubmited ? toggleSize() : null"
        >
          @if (!isSubmited) {
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.12998 15.2901L12.01 11.4101L15.89 15.2901C16.28 15.6801 16.91 15.6801 17.3 15.2901C17.69 14.9001 17.69 14.2701 17.3 13.8801L12.71 9.29006C12.32 8.90006 11.69 8.90006 11.3 9.29006L6.70998 13.8801C6.31998 14.2701 6.31998 14.9001 6.70998 15.2901C7.09998 15.6701 7.73998 15.6801 8.12998 15.2901Z" [attr.fill]="useInverseSlideup ? '#000000' : '#FFFFFF'"/>
            </svg>
          } @else {
            <svg (click)="close()" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.37142 18.7071C6.98251 19.096 6.34612 19.096 5.95721 18.7071C5.5683 18.3182 5.5683 17.6818 5.95721 17.2929L17.2709 5.97918C17.6598 5.59027 18.2962 5.59027 18.6851 5.97918C19.074 6.36809 19.074 7.00449 18.6851 7.3934L7.37142 18.7071Z" [attr.fill]="useInverseSlideup ? '#000000' : '#FFFFFF'"/>
              <path d="M17.2709 18.7071C17.6598 19.096 18.2962 19.096 18.6851 18.7071C19.074 18.3182 19.074 17.6818 18.6851 17.2929L7.37142 5.97918C6.98251 5.59027 6.34612 5.59027 5.95721 5.97918C5.5683 6.36809 5.5683 7.00449 5.95721 7.3934L17.2709 18.7071Z" [attr.fill]="useInverseSlideup ? '#000000' : '#FFFFFF'"/>
            </svg>
          }
        </div>

        <div class="captureBody">
          @if (!isSubmited) {
            <div
              class="wysiwyg pb-6 mt-0 pr-14 sm:pr-8 pt-8 pl-6 sm:pl-8 phone-capture-content cursor-pointer"
              [innerHtml]="displayContent"
              (click)="toggleSize()"
            ></div>
            @if (!displayContent) {
              <div
                class="pb-6 -mt-8 pr-14 sm:pr-8 pt-0 sm:pt-2 pl-6 sm:pl-8 phone-capture-no-content cursor-pointer"
                (click)="toggleSize()"
              >
                <h4 class="pr-6 sm:pr-0">{{ phoneCaptureTitle }}</h4>
                <div class="wysiwyg" [innerHTML]="phoneCaptureContent"></div>
              </div>
            }
          }

          @if (isSubmited) {
            <div class="mb-v-spacing mt-0 pr-6 sm:pr-8 pt-8 pl-6 sm:pl-8">
              <div class="wysiwyg" [innerHTML]="phoneCaptureContent"></div>
            </div>
          }

          @if (!isSubmited) {
            <div class="sm:flex sm:flex-row pl-6 sm:pl-8 pr-6 sm:pr-8">
              <input
                type="tel"
                placeholder="Phone Number"
                class="outline-none h-12 rounded-md p-1 pl-3 border border-gray-300 text-base mr-2 text-gray-900 w-full mb-2 sm:mb-0"
                [class.slideup-inverse-input]="useInverseSlideup"
                formControlName="phoneNumber"
                required
                trackElement
                elementId="page_phonecapture_phone"
                elementType="phone_form"
                elementPosition="footer"
                [trackEvents]="['focus']"
              />
              <button
                class="btn-discount w-full sm:h-auto h-12 cursor-pointer inline-flex items-center justify-center rounded-full text-vis-reverse"
                [ngClass]="useInverseSlideup ? 'bg-ace-pink-600 font-bold hover:bg-ace-pink-700' : 'bg-ace-blue-600 hover:bg-ace-blue-700'"
                (click)="submit()"
              >
                {{ buttonLabel }}
              </button>
            </div>
            @if (isPhoneInvalid) {
              <p class="text-xs pl-6 pr-6">{{ phoneError }}</p>
            }
            <p class="text-xs pl-6 pr-6 mt-2">
              Providing your phone number means you agree to receive promotional messaging from {{ brandName || 'us' }}.
              Frequency may vary. Msg &amp; data rates may apply. Reply HELP for help and STOP to cancel at any time. View
              our
              <a [href]="termsOfServiceUrl" target="_blank" rel="noopener noreferrer" class="underline">Terms of Service</a>
              and
              <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer" class="underline">Privacy Policy</a>.
            </p>
          }
        </div>
      </div>
    </div>
  }
</form>
